export default __webpack_public_path__ + "static/media/Group 212.768a5b45.jpg";